<template>
  <div @click="hideMenu">
    <!-- FILTROS -->
    <div class="card">
      <div class="card-header">
        <button style="float: left; margin-top: -5px" type="button" class="btn btn-tool" data-toggle="collapse" href="#collapse1">
          <i class="fas fa-minus"></i>
        </button>
        <h5 class="card-title" id="accordion">Filtrar propostas</h5>
      </div>
      <!--<div id="collapse1" class="collapse" data-parent="#accordion"> -->
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label style="font-weight: bold">Apelido</label>
              <input class="form-control" id="descricao" v-model="apelido" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label style="font-weight: bold">Leilão id</label>
              <input class="form-control" id="descricao" v-model="leilao_id" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label style="font-weight: bold">Status</label>
              <select
                @change="buscarPropostas(true)"
                class="custom-select rounded-0"
                id="endereco_estado"
                v-model="filtro_proposta_status"
                style="text-transform: uppercase"
              >
                <option value="nao_revogadas">Não revogadas</option>
                <option value="revogadas">Revogadas</option>
                <option value="todas">Todas</option>
              </select>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <button type="button" class="btn btn-primary" @click="buscarPropostas">Buscar</button>

              <button type="button" class="btn btn-default" @click="limparFiltros" style="margin-left: 15px">Limpar filtros</button>
            </div>
          </div>
        </div>
        <!--  </div> -->
      </div>
    </div>

    <!-- TABELA DE PROPOSTAS -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Propostas</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th style="width: 30%">Usuário</th>
              <th style="width: 30%">Leilão</th>
              <th style="width: 30%">Proposta</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(proposta, index) in propostas"
              :key="proposta"
              @contextmenu.prevent="onRightClick($event, proposta)"
              :style="getStyle(proposta.user_status)"
              :class="getClass(proposta.user_status)"
              style="cursor: pointer"
            >
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Usuário">
                <label>Apelido:</label>

                <i class="fa-solid fa-circle" style="margin-right: 1px; margin-left: 3px" :style="getStyleOnline(proposta)"></i>
                {{ proposta.apelido }}
                <br />

                <label>Nome:</label>
                {{ proposta.nome }}
                <br />

                <label>CPF:</label>
                {{ proposta.cpf }}
                <br />

                <label>Status usuário:</label>
                {{ proposta.user_status }}

                <div class="card" style="background-color: rgb(219, 181, 10) !important" v-if="proposta.pendencias.length">
                  <div class="card-body p-2">
                    <i class="fa-solid fa-circle-exclamation" style="margin-right: 2px"></i>
                    <b>Possui pendências, verificar:</b>
                    <br />
                    <p v-for="(pendencia, index) in proposta.pendencias" :key="pendencia">
                      <span>Data: {{ formatDate(pendencia.created_at) }}</span>
                      <br />
                      <span v-html="pendencia.conteudo"></span>
                    </p>
                  </div>
                </div>
              </td>

              <td data-label="Leilão/Lote">
                <div>
                  <b>Leilão:&nbsp;</b>
                  <a href="#" data-toggle="modal" data-target="#detalhes-leilao-modal" @click="proposta_selecionada = proposta">
                    {{ proposta.leilao_id }} - {{ proposta.leilao_titulo }}
                  </a>
                </div>
                <div>
                  <b>Lote:&nbsp;</b>
                  <!--<a :href="'/admin/leilao/' + proposta.lote_id + '/lotes/editar/' + proposta.lote_id"> -->
                  <a>{{ proposta.lote_numero }} - {{ proposta.lote_titulo }}</a>
                </div>
                <div>
                  <b>Praça:&nbsp;</b>
                  {{ proposta.praca }}
                </div>
                <div>
                  <b>Data leilão:&nbsp;</b>
                  {{ formatDate(proposta.data_leilao) }}
                </div>
              </td>

              <td data-label="Proposta">
                <div style="text-transform: uppercase">
                  <b>Tipo:&nbsp;</b>
                  {{ proposta.tipo }}
                </div>
                <div>
                  <b>Aberto:&nbsp;</b>
                  {{ convertTiny(proposta.aberto) }}
                </div>
                <div>
                  <b>Data envio:&nbsp;</b>
                  {{ formatDate(proposta.created_at) }}
                </div>
                <div>
                  <br />
                </div>
                <div v-if="proposta.deleted_at" style="color: red">
                  <b>Proposta revogada em:&nbsp;</b>
                  {{ formatDate(proposta.deleted_at) }}
                </div>
              </td>

              <td>
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>
                  <a v-if="!proposta.deleted_at" class="dropdown-item" @click="deletar(proposta)" style="cursor: pointer">
                    <i class="fa-solid fa-trash"></i>
                    &nbsp;&nbsp; Revogar
                  </a>

                  <div class="dropdown-divider"></div>
                  <a
                    class="dropdown-item"
                    data-toggle="modal"
                    data-target="#visualizar-modal"
                    @click="(proposta_selecionada = proposta), (visualizar_proposta = true)"
                    style="cursor: pointer"
                  >
                    <i class="fa-solid fa-search"></i>
                    &nbsp;&nbsp; Visualizar
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div
          id="newMenu"
          style="visibility: hidden; position: absolute; background-color: white; max-width: 300px; line-height: 15px"
          class="dropdown-menu-lg dropdown-menu-right"
        >
          <div class="dropdown-divider"></div>
          <a v-if="!proposta_selecionada.deleted_at" @click="deletar(proposta_selecionada)" class="dropdown-item" style="cursor: pointer">
            <i class="fa-solid fa-trash"></i>
            &nbsp;&nbsp; Revogar
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" style="cursor: pointer" data-toggle="modal" data-target="#visualizar-modal" @click="visualizar_proposta = true">
            <i class="fa-solid fa-search"></i>
            &nbsp;&nbsp; Visualizar
          </a>
        </div>
      </div>
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + propostas.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>

      <!-- MODAL DETALHES LEILÃO -->
      <div class="modal fade" id="detalhes-leilao-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <form @submit.prevent>
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <div class="card">
                  <div
                    class="card-body"
                    style="
                      padding: 0px 0px 0px 0px;
                      text-align: left;
                      font-family: 'Montserrat', sans-serif;
                      text-transform: uppercase;
                      margin: 0px 0px 0px 0px;
                    "
                  >
                    <div style="text-align: left; line-height: 5px" class="p-2">
                      <div style="margin-top: 7px; position: relative">
                        <p style="font-size: 16px; font-weight: bold; word-wrap: break-word">
                          {{ proposta_selecionada.cidade_leilao }} - {{ proposta_selecionada.estado_leilao }}
                        </p>
                        <span style="font-size: 15px; font-weight: bold; margin-top: 4px">
                          {{ getFormatedTitle(proposta_selecionada.leilao_titulo) }}
                        </span>
                        <br />
                      </div>
                    </div>

                    <div style="line-height: 15px; margin-top: 5px; text-align: left" class="p-2">
                      <b style="font-size: 14px">
                        Modalidade:
                        <a style="color: #4a4949; font-weight: 400">{{ proposta_selecionada.leilao_1_modalidade }}</a>
                      </b>
                      <br />
                      <b style="font-size: 14px">
                        Local:
                        <a style="color: #4a4949; font-weight: 400; text-transform: none">{{ proposta_selecionada.leilao_local }}</a>
                      </b>
                    </div>
                    <!-- DATAS E VALORES DOS LEILÕES -->
                    <div v-if="proposta_selecionada.leilao_num_pracas > 1 && !venda_direta" style="text-align: left; line-height: 15px" class="p-2">
                      <div style="font-size: 14px; color: #545353" :class="proposta_selecionada.leilao_1_realizado === 1 ? 'realizado' : ''">
                        <b>1º Leilão:</b>
                        {{ formatDate(proposta_selecionada.leilao_1_data) + "h" }}
                      </div>

                      <!-- DATA 2 -->
                      <div style="font-size: 14px; color: #545353" v-if="proposta_selecionada.leilao_num_pracas >= 2">
                        <b>2º Leilão:</b>
                        {{ formatDate(proposta_selecionada.leilao_2_data) + "h" }}
                      </div>

                      <!-- DATA 3 -->
                      <div style="font-size: 14px; color: #545353" v-if="proposta_selecionada.leilao_num_pracas >= 3">
                        <b>3º Leilão:</b>
                        {{ formatDate(proposta_selecionada.leilao_3_data) + "h" }}
                      </div>

                      <!-- DATA 4 -->
                      <div style="font-size: 14px; color: #545353" v-if="proposta_selecionada.leilao_num_pracas >= 4">
                        <b>4º Leilão:</b>
                        {{ formatDate(proposta_selecionada.leilao_4_data) + "h" }}
                      </div>
                    </div>

                    <!-- ÚNICO LEILÃO-->
                    <div
                      v-else-if="proposta_selecionada.leilao_num_pracas == 1 && !venda_direta"
                      style="padding-left: 8px !important; text-align: left; line-height: 15px; margin-top: 5px"
                      class="p-1"
                    >
                      <div
                        style="font-size: 14px; color: #545353; margin-bottom: 3px"
                        :class="proposta_selecionada.leilao_1_realizado === 1 ? 'realizado' : ''"
                      >
                        <b>Único leilão:</b>
                        {{ formatDate(proposta_selecionada.leilao_1_data) + "h" }}
                      </div>
                    </div>

                    <!-- VENDA DIRETA-->
                    <div v-else-if="venda_direta" style="text-align: center; line-height: 15px; text-transform: none" class="p-1">
                      <p style="font-size: 14px; margin-top: 5px">{{ proposta_selecionada.leilao_local }}</p>
                      <div style="font-size: 14px; color: #545353" :class="proposta_selecionada.leilao_1_realizado === 1 ? 'realizado' : ''">
                        <b style="">Disponível até:</b>
                        {{ formatDate(proposta_selecionada.leilao_1_data) + "h" }}
                        <br />
                        <a>Pelo valor de</a>
                        R$ {{ toCurrency(lote_selecionado.lote_valor_1) }}
                      </div>
                    </div>

                    <!-- ID DO LEILÃO-->
                    <span class="p-2" style="font-size: 15px; font-weight: bold; margin-top: 4px">
                      Leilão ID
                      <a :href="'/admin/leilao/' + proposta_selecionada.leilao_id">
                        {{ proposta_selecionada.leilao_id }}
                      </a>
                    </span>

                    <button
                      style="font-size: 12px; border-radius: 2px; margin-left: 5px; margin-bottom: 12px"
                      type="submit"
                      class="btn btn-default"
                      title="Habilitações"
                      alt="Habilitações"
                    >
                      <div>
                        <i class="fa-solid fa-laptop"></i>
                        {{ proposta_selecionada.total_habilitacoes }}
                      </div>
                    </button>
                  </div>
                </div>

                <button data-dismiss="modal" class="btn btn-danger btn-sm">Fechar</button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- MODAL VISUALIZAR PROPOSTA -->
      <div
        class="modal fade"
        id="visualizar-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
        style="margin-top: 30px"
        v-if="visualizar_proposta"
        @click.self="visualizar_proposta = false"
      >
        <form @submit.prevent>
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="visualizar_proposta = false">&times;</button>
                <h4>Proposta enviada</h4>
                <br />
                <div class="p-2">
                  <proposta :proposta="proposta_selecionada" />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["estados", "comitentes", "processos"],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      proposta_selecionada: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      propostas: [],
      cidades: [],
      id: "",
      estado: "",
      cidade: "",
      comitente: "",
      titulo: "",
      descricao: "",
      local: "",
      tipo: "",
      teste: 0,
      executado: "",
      processo: "",
      somente_pendentes: true,
      apelido: "",
      leilao_id: "",
      visualizar_proposta: "",
      filtro_proposta_status: "nao_revogadas",
    };
  },

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    let page = urlParams.get("page");

    if (page) {
      this.pagina_atual = Number(page);
    }

    this.buscarPropostas();
  },

  methods: {
    getFormatedTitle(title) {
      if (title && title.length > 30) {
        return title.substring(0, 30) + "...";
      } else {
        return title;
      }
    },

    getFormatedText(texto) {
      if (texto && texto.length > 30) {
        return texto.substring(0, 30) + "...";
      } else {
        return texto;
      }
    },

    getClass(status) {
      if (status == "pendente") {
        return "table_todos_line";
      } else if (status == "liberado") {
        return "table_todos_line";
      } else if (status == "bloqueado") {
        return "table_todos_line";
      } else {
        return "";
      }
    },

    limparFiltros() {
      this.somente_pendentes = true;
      this.apelido = "";
      this.leilao_id = "";

      this.buscarPropostas();
    },

    getStyle(status) {
      let style = "cursor:pointer;";

      if (status == "pendente") {
        return style + "background-color: #fcfdcd";
      } else if (status == "liberado") {
        return style + "background-color: #d6fbe4";
      } else if (status == "bloqueado") {
        return style + "background-color: #ffdbdb";
      } else {
        return style;
      }
    },

    getDataProximaPraca(proposta) {
      if (proposta.leilao_oculto || proposta.leilao_retirado || proposta.leilao_suspenso || proposta.leilao_encerrado) {
        return "";
      } else if (proposta.leilao_num_pracas >= 1 && proposta.leilao_1_realizado == 0) {
        return this.formatDate(proposta.leilao_1_data);
      } else if (proposta.leilao_num_pracas >= 2 && proposta.leilao_2_realizado == 0) {
        return this.formatDate(proposta.leilao_2_data);
      } else if (proposta.leilao_num_pracas >= 3 && proposta.leilao_3_realizado == 0) {
        return this.formatDate(proposta.leilao_3_data);
      } else if (proposta.leilao_num_pracas >= 4 && proposta.leilao_4_realizado == 0) {
        return this.formatDate(proposta.leilao_4_data);
      }
    },

    getStyleOnline(user) {
      let online = false;

      if (user.last_seen) {
        let dataReferencia = moment(new Date());
        let data = moment(user.last_seen);

        var duration = moment.duration(dataReferencia.diff(data));
        var min = duration.asMinutes();

        if (min <= 5) {
          online = true;
        }
      }

      if (online) {
        return "color: #007d41";
      } else {
        return "color: gray;";
      }
    },

    getLinkProposta(proposta) {
      let url = process.env.MIX_VUE_APP_URL + "/proposta/" + proposta.hash;

      return url;
    },

    getUrlProposta(proposta) {
      let url = process.env.MIX_VUE_APP_URL + "/proposta/" + proposta.hash;

      if (url && url.length > 30) {
        return url.substring(0, 30) + "...";
      } else {
        return url;
      }
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, proposta) {
      this.proposta_selecionada = proposta;

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 260;
      let y = event.pageY - 405;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      console.log("X depois " + x);

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    changeStatus(leilao, atual) {
      console.log(leilao);

      let data = {
        leilao_id: leilao.id,
        leilao_retirado: this.convertToTiny(leilao.leilao_retirado),
        leilao_encerrado: this.convertToTiny(leilao.leilao_encerrado),
        leilao_suspenso: this.convertToTiny(leilao.leilao_suspenso),
      };

      console.log(data);

      axios
        .post(`/admin/leilao/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    visualizar(proposta) {
      this.proposta_selecionada = proposta;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    getUrlEdit(leilao) {
      return "/admin/leilao/" + leilao.id;
    },

    show(leilao) {
      this.leilao_selecionado = leilao;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        window.history.replaceState(null, null, "?page=" + pagina);

        this.buscarPropostas();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        window.history.replaceState(null, null, "?page=" + this.max_page);

        this.buscarPropostas();
      }
    },

    buscarPropostas(voltar_pagina) {
      if (voltar_pagina) {
        this.inicio = 0;
        this.pagina_atual = 1;
      }

      this.isLoading = true;

      let data = {
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
        desc: true,
        somente_pendentes: this.somente_pendentes,
        apelido: this.apelido,
        leilao_id: this.leilao_id,
        filtro_proposta_status: this.filtro_proposta_status,
      };

      console.log(data);

      axios
        .post(`/admin/propostas/search`, data)
        .then((response) => {
          this.propostas = response.data.propostas;
          this.total = response.data.total;

          console.log("Leilões");
          console.log(this.propostas);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarPropostas();
    },

    deletar(proposta) {
      if (proposta) {
        this.proposta_selecionada = proposta;
      }

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Esta ação é irreversível, deseja continuar?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.proposta_selecionada.id,
            };

            axios
              .post(`/admin/proposta/delete`, data)
              .then((response) => {
                this.showSuccessMessage("Formulário deletado!");
                this.hideMenu();
                this.buscarPropostas();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.leilao_selecionado.id,
        cadastro_tipo: this.leilao_selecionado.cadastro_tipo,
        tipodoc: this.leilao_selecionado.tipodoc,
        estado_civil: this.leilao_selecionado.estado_civil,
        obrigatorio: this.leilao_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
